(function ($) {
    'use strict';

    /**
     * Ajax related behaviour related to "add to cart", "remove from cart", "etc"
     */
    $(function () {

        $(document).on('click', '.js-add_to_cart', function (event) {
            event.preventDefault();

            var $this = $(this);
            $this.addClass('loading');

            var url = $this.attr('href');

            if (url) {
                var product_id = $this.data('product_id');
                var qty = $this.data('qty');

                if (product_id) {

                    var data = {
                        add_product: product_id
                    };

                    if (qty) {



                    } else {
                        qty = $this.closest('.prod__item').find('.cart__item_qty_field').val();
                        data.qty = qty || 1;
                    }

                    console.log('before: ', data);

                    $.ajax({
                        type: "post",
                        url: url,
                        data: data,
                        dataType: 'json'
                    })
                        .done(function (data, textStatus, jqXHR) {

                            if (data.error) {
                                console.error('error', data.message);
                            } else {
                                console.info('success', data.message);
                                if (data.nextUrl) {
                                    window.location.href = data.nextUrl;
                                }
                            }

                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            console.log('ajax failed', textStatus);
                            alert(textStatus);
                        })
                        .always(function (datajqXHR, textStatus, jqXHRerrorThrown) {
                            $this.prop("disabled", false);
                            $this.removeClass('loading');
                        });
                }
            }
        });

        $(document).on('change', '.js-update_cart', function (event) {
            event.preventDefault();

            var $this = $(this);
            var $cart_wrapper = $('.js-cart_wrapper');
            if ($cart_wrapper.length == 0) {
                return false;
            }

            $cart_wrapper.addClass('loading');

            var url = window.location.href;
            var product_id = parseInt($this.data('product_id'));
            var qty = parseInt($this.val());

            var data = {
                update_product: product_id,
                qty: qty
            };

            $.ajax({
                type: "post",
                url: url,
                data: data,
                dataType: 'json'
            })
                .done(function (data, textStatus, jqXHR) {

                    if (data.error) {
                        console.error('error:', data.message);
                    } else {
                        console.info('success:', data.message);

                        var $cart_wrapper = $('.js-cart_wrapper');
                        if ($cart_wrapper.length) {
                            $cart_wrapper.html(data.markup);
                        }
                    }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log('ajax failed', textStatus);
                    alert(textStatus);
                })
                .always(function (datajqXHR, textStatus, jqXHRerrorThrown) {
                    $cart_wrapper.removeClass('loading');
                });

        });

        $(document).on('click', '.js-remove_from_cart', function (event) {
            event.preventDefault();

            var $this = $(this);
            var $cart_wrapper = $('.js-cart_wrapper');
            if ($cart_wrapper.length == 0) {
                return false;
            }

            $cart_wrapper.addClass('loading');

            var url = window.location.href;
            var product_id = parseInt($this.data('product_id'));

            var data = {
                remove_product: product_id,
            };

            $.ajax({
                type: "post",
                url: url,
                data: data,
                dataType: 'json'
            })
                .done(function (data, textStatus, jqXHR) {

                    if (data.error) {
                        console.error('error:', data.message);
                    } else {
                        console.info('success:', data.message);

                        var $cart_wrapper = $('.js-cart_wrapper');
                        if ($cart_wrapper.length) {
                            $cart_wrapper.html(data.markup);
                        }
                    }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log('ajax failed', textStatus);
                    alert(textStatus);
                })
                .always(function (datajqXHR, textStatus, jqXHRerrorThrown) {
                    $cart_wrapper.removeClass('loading');
                });

        });
    });

}(jQuery));